import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './SearchResults.module.css';

import speechIcon from '../../Assets/icons/icon2.png';
import audioIcon from '../../Assets/icons/icon3.png';
import videoIcon from '../../Assets/icons/icon4.png';
import productionIcon from '../../Assets/icons/icon1.png';
import defaultImage from '../../Assets/speeches/v1_83.png';

const SearchResults = () => {
  const { search } = useParams();
  const navigate = useNavigate();
  const [searchResults, setSearchResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const decodedSearch = decodeURIComponent(search || '');

  const categoryConfig = {
    speech: {
      name: 'بيانات',
      icon: speechIcon,
      color: '#1a5f3f', 
      route: '/speeches'
    },
    audio: {
      name: 'فایل‌های صوتی',
      icon: audioIcon,
      color: '#2d7a4d', 
      route: '/audios'
    },
    video: {
      name: 'ویدیوها',
      icon: videoIcon,
      color: '#0f4229', 
      route: '/videos'
    },
    production: {
      name: 'تولیدات',
      icon: productionIcon,
      color: '#1a5f3f', 
      route: '/productions'
    }
  };

  useEffect(() => {
    const fetchSearchResults = async () => {
      setLoading(true);
      setError(null);

      const PickLanguage = localStorage.getItem('siteLanguage')
      let response;

      try {
         
        if(PickLanguage === "fa") {
          response = await fetch(
          `https://api.nasrollah.info/fa/?function=search&params=${encodeURIComponent(decodedSearch)}`
        );
        }else{
          response = await fetch(
          `https://api.nasrollah.info/ar/?function=search&params=${encodeURIComponent(decodedSearch)}`
        );
        }

        if (!response.ok) {
          throw new Error('خطا در دریافت نتایج جستجو');
        }

        const data = await response.json();
        setSearchResults(data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (decodedSearch) {
      fetchSearchResults();
    }
  }, [decodedSearch]);

  const groupedResults = searchResults.reduce((acc, item) => {
    const category = item.name_category;
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(item);
    return acc;
  }, {});

  Object.keys(groupedResults).forEach(category => {
    groupedResults[category].sort((a, b) => 
      new Date(b.original_time_post) - new Date(a.original_time_post)
    );
  });

  const formatSlug = (slug) => {
    if (!slug) return '';
    return slug.replace(/\s+/g, '-');
  };

  const convertToPersianYear = (dateString) => {
    if (!dateString) return '';
    
    try {
      let date;
      
      if (dateString.includes('/')) {
        const parts = dateString.split('/');
        if (parts.length === 3) {
          const year = parts.find(part => part.length === 4);
          if (year) {
            date = new Date(parseInt(year), 0, 1); 
          } else {
            date = new Date(dateString);
          }
        } else {
          date = new Date(dateString);
        }
      } else {
        date = new Date(dateString);
      }
      
      if (isNaN(date.getTime())) {
        const yearMatch = dateString.match(/\d{4}/);
        if (yearMatch) {
          date = new Date(parseInt(yearMatch[0]), 0, 1);
        } else {
          return '';
        }
      }
      
      const gregorianYear = date.getFullYear();

      const gregorianMonth = date.getMonth() + 1; 
      const gregorianDay = date.getDate();
      
      let persianYear;
      
      if (gregorianMonth < 3 || (gregorianMonth === 3 && gregorianDay < 21)) {
        persianYear = gregorianYear - 622;
      } else {
        persianYear = gregorianYear - 621;
      }
      
      return persianYear.toString();
    } catch (error) {
      console.error('Error converting to Persian year:', error);
      return '';
    }
  };

  const handleCardClick = (post) => {
    const config = categoryConfig[post.name_category];
    if (config) {
      const formattedSlug = formatSlug(post.slug_post);
      const persianYear = convertToPersianYear(post.original_time_post);
      navigate(`${config.route}/${persianYear}/${formattedSlug}/${post.id_post}`);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fa-IR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className={styles.searchContainer}>
        <div className={styles.loadingState}>
          <div className={styles.spinner}></div>
          <p>در حال جستجو...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.searchContainer}>
        <div className={styles.errorState}>
          <h2>خطا در جستجو</h2>
          <p>{error}</p>
          <button 
            onClick={() => window.location.reload()} 
            className={styles.retryButton}
          >
            تلاش مجدد
          </button>
        </div>
      </div>
    );
  }

  const totalResults = searchResults.length;

  let response = localStorage.getItem("siteLanguage");

  if (response === "fa") {
    return (
    <div className={styles.searchContainer}>
      <div className={styles.searchHeader}>
        <h1 className={styles.searchTitle}>
          نتایج جستجو برای: <span className={styles.searchTerm}>"{decodedSearch}"</span>
        </h1>
        <div className={styles.resultsCount}>
          {totalResults > 0 ? (
            <span>{totalResults} نتیجه یافت شد</span>
          ) : (
            <span>هیچ نتیجه‌ای یافت نشد</span>
          )}
        </div>
      </div>

      {totalResults === 0 ? (
        <div className={styles.noResults}>
          <div className={styles.noResultsIcon}>🔍</div>
          <h3>نتیجه‌ای یافت نشد</h3>
          <p>لطفاً با کلمات کلیدی دیگری جستجو کنید</p>
        </div>
      ) : (
        <div className={styles.categorySections}>
          {Object.entries(groupedResults).map(([category, posts]) => {
            const config = categoryConfig[category];
            if (!config) return null;

            return (
              <div key={category} className={styles.categorySection}>
                <div className={styles.categoryHeader}>
                  <div className={styles.categoryTitle}>
                    <img 
                      src={config.icon} 
                      alt={config.name}
                      className={styles.categoryIcon}
                    />
                    <h2 style={{ color: config.color }}>
                      {config.name}
                    </h2>
                    <span className={styles.categoryCount}>
                      ({posts.length})
                    </span>
                  </div>
                </div>

                <div className={styles.postsGrid}>
                  {posts.map((post) => (
                    <div
                      key={post.id_post}
                      className={styles.postCard}
                      onClick={() => handleCardClick(post)}
                      style={{ '--category-color': config.color }}
                    >
                      <div className={styles.postImageContainer}>
                        <img
                          src={post.featured_post}
                          alt={post.title_post}
                          className={styles.postImage}
                          onError={(e) => {
                            e.target.src = defaultImage;
                          }}
                        />
                        <div className={styles.postOverlay}>
                          <img
                            src={config.icon}
                            alt={config.name}
                            className={styles.postIcon}
                          />
                        </div>
                      </div>

                      <div className={styles.postContent}>
                        <h3 className={styles.postTitle}>
                          {post.title_post}
                        </h3>
                        
                        <div className={styles.postMeta}>
                          <span className={styles.postAuthor}>
                            {post.author_post}
                          </span>
                          <span className={styles.metaSeparator}>•</span>
                          <span className={styles.postDate}>
                            {formatDate(post.original_time_post)}
                          </span>
                        </div>

                        <div className={styles.postCategory}>
                          <span 
                            className={styles.categoryBadge}
                            style={{ backgroundColor: config.color }}
                          >
                            {config.name}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
  }else {
    return (
    <div className={styles.searchContainer}>
      <div className={styles.searchHeader}>
        <h1 className={styles.searchTitle}>
          نتائج البحث عن: <span className={styles.searchTerm}>"{decodedSearch}"</span>
        </h1>
        <div className={styles.resultsCount}>
          {totalResults > 0 ? (
            <span>تم العثور على {totalResults} نتيجة</span>
          ) : (
            <span>لم يتم العثور على أي نتائج</span>
          )}
        </div>
      </div>

      {totalResults === 0 ? (
        <div className={styles.noResults}>
          <div className={styles.noResultsIcon}>🔍</div>
          <h3>لم يتم العثور على نتائج</h3>
          <p>يرجى البحث بكلمات مفتاحية أخرى</p>
        </div>
      ) : (
        <div className={styles.categorySections}>
          {Object.entries(groupedResults).map(([category, posts]) => {
            const config = categoryConfig[category];
            if (!config) return null;

            return (
              <div key={category} className={styles.categorySection}>
                <div className={styles.categoryHeader}>
                  <div className={styles.categoryTitle}>
                    <img 
                      src={config.icon} 
                      alt={config.name}
                      className={styles.categoryIcon}
                    />
                    <h2 style={{ color: config.color }}>
                      {config.name}
                    </h2>
                    <span className={styles.categoryCount}>
                      ({posts.length})
                    </span>
                  </div>
                </div>

                <div className={styles.postsGrid}>
                  {posts.map((post) => (
                    <div
                      key={post.id_post}
                      className={styles.postCard}
                      onClick={() => handleCardClick(post)}
                      style={{ '--category-color': config.color }}
                    >
                      <div className={styles.postImageContainer}>
                        <img
                          src={post.featured_media_post || defaultImage}
                          alt={post.title_post}
                          className={styles.postImage}
                          onError={(e) => {
                            e.target.src = defaultImage;
                          }}
                        />
                        <div className={styles.postOverlay}>
                          <img
                            src={config.icon}
                            alt={config.name}
                            className={styles.postIcon}
                          />
                        </div>
                      </div>

                      <div className={styles.postContent}>
                        <h3 className={styles.postTitle}>
                          {post.title_post}
                        </h3>
                        
                        <div className={styles.postMeta}>
                          <span className={styles.postAuthor}>
                            {post.author_post}
                          </span>
                          <span className={styles.metaSeparator}>•</span>
                          <span className={styles.postDate}>
                            {formatDate(post.original_time_post)}
                          </span>
                        </div>

                        <div className={styles.postCategory}>
                          <span 
                            className={styles.categoryBadge}
                            style={{ backgroundColor: config.color }}
                          >
                            {config.name}
                          </span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );

  }

};

export default SearchResults;
